<div>
  <div class="header">
    <div class="notification-block" *ngFor="let message of messages | keyvalue" fxFlex>
      <div class="notification" fxLayout="row">
        <p class="notification-text">
          {{ displayText(message.key) }}
        </p>
        <div
          class="icon"
          [inlineSVG]="'assets/svg/close.svg'"
          [setSVGAttributes]="{ width: 24, height: 24 }"
          (click)="close(message.key)"></div>
      </div>
    </div>
  </div>
</div>
